import HiringAnswers from '@/modules/common/hiring/models/APP/HiringAnswers'
import LifeHiringInsured from './LifeHiringInsured'
import { ForWhomEnum, UserRoleEnum } from '@/modules/core/models/enums'
import LifeReevaluationOption from '@/modules/life/common/models/APP/LifeReevaluationOption'

export default class LifeHiringAnswers extends HiringAnswers<LifeHiringInsured> {
  protected _holder = new LifeHiringInsured()

  insuranceType: string | null
  coveragesCapital: number
  reevaluationType: LifeReevaluationOption | null

  constructor(data: any = {}) {
    super(data)

    this.insureds = data.insureds
    this.holder = data.holder
    // ? this.forWhomPeople = 1
    this.insuranceType = data.insuranceType ?? null
    this.insureds = data.insureds ?? []
    this.coveragesCapital = data.coveragesCapital ?? 0

    this.currentInsured = data.currentInsured ?? null
    this.reevaluationType = data.reevaluationType
      ? new LifeReevaluationOption(data.reevaluationType)
      : null
  }

  get forWhom() {
    const holderRole = this.holder.role
    if (holderRole === UserRoleEnum.HOLDER_NOT_INSURED) {
      return ForWhomEnum.NOT_ME
    }

    return ForWhomEnum.ME
  }

  get insureds(): LifeHiringInsured[] {
    return this._insureds
  }

  set insureds(value: LifeHiringInsured[]) {
    this._insureds = value?.map((i) => new LifeHiringInsured(i)) ?? []
  }

  get holder(): LifeHiringInsured {
    return this._holder
  }

  set holder(value: LifeHiringInsured | undefined) {
    this._holder.updateAttributes(value ?? {})
  }

  get currentInsured(): LifeHiringInsured | null {
    return this._currentInsured ?? null
  }

  set currentInsured(value: LifeHiringInsured | null | undefined) {
    this._currentInsured = value ? new LifeHiringInsured(value) : null
  }

  updateAttributes(newAttributes: Partial<LifeHiringAnswers>) {
    Object.assign(this, newAttributes)
  }

  hasBetterAssurance(): boolean {
    return !!this.insureds.find((insured) => insured.additionalCoverages?.length)
  }
}
